import React from "react";
import images from "../data/image-gallery-data";

const Shimadzu = () => {
    const processedImages = images.filter(item => item.manufacturer === "Shimadzu");
  return (
    <div className="row">
      <React.Fragment>
        {processedImages.map((item) => {
          return (
            <React.Fragment key={item.id}>
              <div className="col-lg-4 col-md-12 mb-4 mb-lg-0 shadow">
                <figure>
                  <img
                    src={item.location}
                    className="w-100 shadow-1-strong rounded mb-4"
                    alt={item.title ? `${item.title} by ${item.manufacturer}` : `${item.manufacturer} medical imaging product`}
                  />
                  <figcaption className="caption-text">{item.title} </figcaption>
                </figure>
              </div>
            </React.Fragment>
          );
        })}
      </React.Fragment>
    </div>
  );
};

export default Shimadzu;
